import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import axios from "axios";
import useWebsite from "@/composables/useWebsite.js";

const getAccountStatus = (account) => {
  if (!account) {
    return 'pending';
  }
  if (account.status > 0) {
    return 'error';
  }
  return 'connected';
};

export const useGoogleAccounts = () => {
  const { websiteId } = useWebsite();

  const query = useQuery({
    queryKey: ['connected-accounts'],
    queryFn: async () => {
      const { data } = await axios.get('/onboarding/fetch-connected-accounts');
      return data;
    },
  });

  const connectedAccounts = computed(() => query.data.value?.connectedAccounts);

  const analyticsStatus = computed(() => getAccountStatus(connectedAccounts.value?.analytics));
  const searchConsoleStatus = computed(() => getAccountStatus(connectedAccounts.value?.searchConsole));
  const businessProfileStatus = computed(() => getAccountStatus(connectedAccounts.value?.businessProfile?.account_connection));

  const connectedAccountsSettingsUrl = computed(
    () => `/website/settings/${websiteId.value}#connected_accounts`,
  );

  const analyticsUri = computed(() =>
    analyticsStatus.value === 'error' ? `/website/settings/${websiteId.value}` : '/google/connect/analytics'
  );

  const searchConsoleUri = computed(() =>
    searchConsoleStatus.value === 'error' ? `/website/settings/${websiteId.value}` : '/google/connect/console'
  );

  const businessProfileUri = computed(() =>
    businessProfileStatus.value === 'error' ? '/local/business-profile' : '/google/connect/business'
  );

  return {
    ...query,
    connectedAccounts,
    analyticsStatus,
    searchConsoleStatus,
    businessProfileStatus,
    analyticsUri,
    searchConsoleUri,
    businessProfileUri,
  };
};
